/* eslint-disable max-len */

const constants = {};

constants.DRYNOTES_LOGIN =
  process.env.DRYNOTES_LOGIN || 'http://drynotes.cc:5838/login';

constants.API_BASE = process.env.API_BASE || 'http://drynotes.cc:2143';
constants.APP_BASE = process.env.APP_BASE || 'http://drynotes.cc:3578';
constants.DRYNOTES_HOST = process.env.DRYNOTES_HOST || '0.0.0.0';
constants.DRYNOTES_HOST_NAME = process.env.DRYNOTES_HOST_NAME || 'drynotes.cc';
constants.DRYNOTES_PORT = process.env.DRYNOTES_PORT || 3578;
constants.DRYNOTES_ENV = process.env.DRYNOTES_ENV || 'development';
constants.HOT_RELOADING = process.env.HOT_RELOADING || false;
constants.NODE_ENV = process.env.NODE_ENV || 'development';
constants.LOG_LEVEL = process.env.LOG_LEVEL || 'debug';
constants.GA_TRACKING_ID = process.env.GA_TRACKING_ID || 'UA-6750698-26';
constants.FIREBASE_API_KEY =
  process.env.FIREBASE_API_KEY || 'AIzaSyBPc_k_c2zfS93B7xnHU6gI03mnZCYoFQ4';
constants.FIREBASE_AUTH_DOMAIN =
  process.env.FIREBASE_AUTH_DOMAIN || 'endless-ripple-418.firebaseapp.com';
constants.FIREBASE_PROJECT_ID =
  process.env.FIREBASE_PROJECT_ID || 'endless-ripple-418';
constants.FIREBASE_DATABASE_URL =
  process.env.FIREBASE_DATABASE_URL || 'https://endless-ripple-418.firebaseio.com';
constants.FIREBASE_STORAGE_BUCKET =
  process.env.FIREBASE_STORAGE_BUCKET || 'endless-ripple-418.appspot.com';
constants.FIREBASE_MESSAGING_SENDER_ID =
  process.env.FIREBASE_MESSAGING_SENDER_ID || '671966328064';
constants.FIREBASE_APP_ID =
  process.env.FIREBASE_APP_ID || '1:671966328064:web:67d17eba1343535f';
constants.FIREBASE_MEASUREMENT_ID =
  process.env.FIREBASE_MEASUREMENT_ID || '';

constants.ACTION_TYPES = {
  ACTIVATE_NOTE: 'ACTIVATE_NOTE',
  ADD_LABEL: 'ADD_LABEL',
  ADD_NOTE: 'ADD_NOTE',
  ADD_NOTEBOOK: 'ADD_NOTEBOOK',
  ATTACH_LOCAL_DOCUMENTS_UPLOADED: 'ATTACH_LOCAL_DOCUMENTS_UPLOADED',
  CHANGE_EDITOR: 'CHANGE_EDITOR',
  CHANGED_FONT_COLOR: 'CHANGED_FONT_COLOR',
  CLOSE_NOTE: 'CLOSE_NOTE',
  CLOSE_TRASH_NOTE: 'CLOSE_TRASH_NOTE',
  CREATED_NOTE: 'CREATED_NOTE',
  CREATED_NOTEBOOK: 'CREATED_NOTEBOOK',
  DEACTIVATE_NOTE: 'DEACTIVATE_NOTE',
  DELETED_NOTE: 'DELETED_NOTE',
  FETCHED_REQUIRED_APP_DATA: 'FETCHED_REQUIRED_APP_DATA',
  FILES_UPLOAD_INITIALIZED: 'FILES_UPLOAD_INITIALIZED',
  FILES_UPLOADED: 'FILES_UPLOADED',
  FILES_UPLOADING: 'FILES_UPLOADING',
  MODAL_TOGGLE_VISIBILITY: 'MODAL_TOGGLE_VISIBILITY',
  OPEN_FILE: 'OPEN_FILE',
  OPEN_NOTE: 'OPEN_NOTE',
  OPEN_TRASH_NOTE: 'OPEN_TRASH_NOTE',
  PROFILE_TOGGLE_VISIBILITY: 'PROFILE_TOGGLE_VISIBILITY',
  RECEIVE_LABELS: 'RECEIVE_LABELS',
  RECEIVE_NOTEBOOKS: 'RECEIVE_NOTEBOOKS',
  RECEIVE_TRASHED_NOTES: 'RECEIVE_TRASHED_NOTES',
  RECEIVED_AREAS_OF_FOCUS_COLLECTIONS: 'RECEIVED_AREAS_OF_FOCUS_COLLECTIONS',
  RECEIVED_AREAS_OF_FOCUS_COLLECTION: 'RECEIVED_AREAS_OF_FOCUS_COLLECTION',
  REQUEST_AREAS_OF_FOCUS_COLLECTION: 'REQUEST_AREAS_OF_FOCUS_COLLECTION',
  RECEIVED_OPEN_ENTITIES: 'RECEIVED_OPEN_ENTITIES',
  RECEIVED_NOTE: 'RECEIVED_NOTE',
  RECEIVED_NOTES: 'RECEIVED_NOTES',
  RECEIVED_SYNCED_NOTES: 'RECEIVED_SYNCED_NOTES',
  REMOVE_NOTE_FROM_AREAS_OF_FOCUS_COLLECTION:
    'REMOVE_NOTE_FROM_AREAS_OF_FOCUS_COLLECTION',
  REMOVED_NOTE_FROM_AREAS_OF_FOCUS_COLLECTION:
    'REMOVED_NOTE_FROM_AREAS_OF_FOCUS_COLLECTION',
  REQUEST_AREAS_OF_FOCUS_COLLECTIONS: 'REQUEST_AREAS_OF_FOCUS_COLLECTIONS',
  REQUEST_AREAS_OF_FOCUS_ITEMS: 'REQUEST_AREAS_OF_FOCUS_ITEMS',
  REQUEST_LABELS: 'REQUEST_LABELS',
  REQUEST_NOTE: 'REQUEST_NOTE',
  REQUEST_NOTEBOOKS: 'REQUEST_NOTEBOOKS',
  REQUEST_NOTES: 'REQUEST_NOTES',
  REQUEST_TRASHED_NOTES: 'REQUEST_TRASHED_NOTES',
  SELECT_NOTE: 'SELECT_NOTE',
  SELECT_NOTEBOOK: 'SELECT_NOTEBOOK',
  SELECT_TRASH_NOTE: 'SELECT_TRASH_NOTE',
  SEND_NOTE_TO_AREAS_OF_FOCUS_COLLECTION:
    'SEND_NOTE_TO_AREAS_OF_FOCUS_COLLECTION',
  SET_BREAKPOINT: 'SET_BREAKPOINT',
  SHOW_ADD_TO_LIST: 'SHOW_ADD_TO_LIST',
  SHOW_MODAL: 'SHOW_MODAL',
  SIDEBAR_TOGGLE_VISIBILITY: 'SIDEBAR_TOGGLE_VISIBILITY',
  SUBMIT_NOTE: 'SUBMIT_NOTE',
  SUBMIT_NOTEBOOK: 'SUBMIT_NOTEBOOK',
  TOGGLE_ATTACHMENTS_SECTION: 'TOGGLE_ATTACHMENTS_SECTION',
  TOGGLE_ERROR_PAGE: 'TOGGLE_ERROR_PAGE',
  TOGGLE_NOTE_EDITABILITY: 'TOGGLE_NOTE_EDITABILITY',
  TOGGLE_NOTE_PIN: 'TOGGLE_NOTE_PIN',
  TOGGLE_NOTE_TABS_MOBILE_VIEW: 'TOGGLE_NOTE_TABS_MOBILE_VIEW',
  TOGGLE_NOTEBOOK_MODAL: 'TOGGLE_NOTEBOOK_MODAL',
  TOGGLE_PANELS_VISIBILITY: 'TOGGLE_PANELS_VISIBILITY',
  TOGGLE_SIDEBAR_VISIBILITY: 'TOGGLE_SIDEBAR_VISIBILITY',
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  TOGGLE_SNIPPET_OVERFLOW_DELETE: 'TOGGLE_SNIPPET_OVERFLOW_DELETE',
  TOGGLE_SNIPPET_OVERFLOW_MENU: 'TOGGLE_SNIPPET_OVERFLOW_MENU',
  TRASH_NOTE: 'TRASH_NOTE',
  UPDATE_MODAL: 'UPDATE_MODAL',
  UPDATE_NOTE_BODY: 'UPDATE_NOTE_BODY',
  UPDATE_NOTE_TITLE: 'UPDATE_NOTE_TITLE',
  UPDATE_NOTE: 'UPDATE_NOTE',
  UPDATE_USER_SETTINGS: 'UPDATE_USER_SETTINGS',
  RESET_EDITOR_NOTES: 'RESET_EDITOR_NOTES',
  RECEIVED_USER_SETTINGS: 'RECEIVED_USER_SETTINGS',
  SUBMIT_AOF_COLLECTION: 'SUBMIT_AOF_COLLECTION',
  AOF_COLLECTION_NOTEBOOK: 'AOF_COLLECTION_NOTEBOOK',
  ADD_AOF_COLLECTION: 'ADD_AOF_COLLECTION',
  TOGGLE_AOF_COLLECTION_MODAL: 'TOGGLE_AOF_COLLECTION_MODAL',
  TOGGLE_PALETTE: 'TOGGLE_PALETTE',
  UPDATE_SELECTED_AREAS_OF_FOCUS_COLLECTION:
    'UPDATE_SELECTED_AREAS_OF_FOCUS_COLLECTION',
  TOGGLE_HEADER_CHILD_MENU: 'TOGGLE_HEADER_CHILD_MENU',
  ADD_AREA_OF_FOCUS_TO_NOTE: 'ADD_AREA_OF_FOCUS_TO_NOTE',
  REMOVE_AREA_OF_FOCUS_TO_NOTE: 'REMOVE_AREA_OF_FOCUS_TO_NOTE',
  SET_AREA_OF_FOCUS_COLLECTION: 'SET_AREA_OF_FOCUS_COLLECTION',
  UPDATED_NOTEBOOK: 'UPDATED_NOTEBOOK',
  TOGGLE_QUICKSEARCH_VISIBILITY: 'TOGGLE_QUICKSEARCH_VISIBILITY',
  QUICKSEARCH_REQUEST_QUERY: 'QUICKSEARCH_REQUEST_QUERY',
  QUICKSEARCH_RESULTS: 'QUICKSEARCH_RESULTS',
  QUICKSEARCH_CLEAR_RESULTS: 'QUICKSEARCH_CLEAR_RESULTS',
  QUICKSEARCH_SELECTED_INDEX: 'QUICKSEARCH_SELECTED_INDEX',
  QUICKSEARCH_SELECT_NEXT_RESULT: 'QUICKSEARCH_SELECT_NEXT_RESULT',
  QUICKSEARCH_SELECT_PREVIOUS_RESULT: 'QUICKSEARCH_SELECT_PREVIOUS_RESULT',
  CLOSE_QUICKSEARCH_VISIBILITY: 'CLOSE_QUICKSEARCH_VISIBILITY',
  HAS_LOCAL_DATABASE_CONTENT: 'HAS_LOCAL_DATABASE_CONTENT',
  SET_CHROME_STATE_MOBILE: 'SET_CHROME_STATE_MOBILE',
  SET_CHROME_STATE: 'SET_CHROME_STATE',
  SET_CHROME_STATE_MOBILE_RAW: 'SET_CHROME_STATE_MOBILE_RAW',
  SET_CHROME_STATE_RAW: 'SET_CHROME_STATE_RAW',
  RECEIVED_USER_PANEL_CONFIGS: 'RECEIVED_USER_PANEL_CONFIGS',
  SAVE_USER_PANEL_CONFIGS: 'SAVE_USER_PANEL_CONFIGS',
  SAVING_USER_PANEL_CONFIGS: 'SAVING_USER_PANEL_CONFIGS',
  USER_SETTINGS_SUCCESS: 'USER_SETTINGS_SUCCESS',
  USER_SETTINGS_FAILURE: 'USER_SETTINGS_FAILURE',
};

constants.EDITOR_COMMAND_ICON_MAP = {
  bold: 'format_bold',
  italic: 'format_italic',
  underline: 'format_underlined',
  code: 'code',
  superscript: 'vertical_align_top',
  subscript: 'vertical_align_bottom',
  strikethrough: 'format_strikethrough',
  highlight: 'highlight',
  horizontal_rule: 'remove',
  checkbox: 'check',
  code_block: 'code',
  clear_all: 'clear_all',
  'bulleted-list': 'format_list_bulleted',
  'numbered-list': 'format_list_numbered',
  indent_list: 'format_indent_increase',
  outdent_list: 'format_indent_decrease',
  attach_file: 'attach_file',
  view_html: 'flip_to_back',
  toggle_attachments: 'list_alt',
};

constants.EDITOR_COMMAND_NAME_MAP = {
  bold: 'bold',
  italic: 'italic',
  underline: 'underline',
  code: 'code',
  superscript: 'superscript',
  subscript: 'subscript',
  strikethrough: 'strikethrough',
  highlight: 'highlight',
  horizontal_rule: 'horizontal_rule',
  checkbox: 'checkbox',
  code_block: 'code_block',
  clear_all: 'clear_all',
  'bulleted-list': 'bulleted-list',
  'numbered-list': 'numbered-list',
  unordered_list: 'bulleted-list',
  ordered_list: 'numbered-list',
  indent_list: 'indent_list',
  outdent_list: 'outdent_list',
  enter_list_item: 'enter_list_item',
  check_list: 'check_list',
  enter_check_list_item: 'enter_check_list_item',
  font_color: 'font_color',
  font_family: 'font_family',
  font_size: 'font_size',
  background_color: 'background_color',
  attach_file: 'attach_file',
  view_html: 'view_html',
  toggle_attachments: 'toggle_attachments',
  heading: 'heading',
  hard_break: 'hard_break',
  image: 'image',
  enter: 'enter',
  exitCode: 'exitCode',
  backspace: 'backspace',
  mod_backspace: 'mod_backspace',
  delete: 'delete',
  mod_delete: 'mod_delete',
  select_all: 'select_all',
  link: 'link',
  unlink: 'unlink',
  undo: 'undo',
  redo: 'redo',
};

constants.BREAKPOINTS = {
  mobile: 320,
  mobileLandscape: 480,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1200,
  desktopLarge: 1500,
  desktopWide: 1920,
};

constants.LOCAL_DATABASE_KEYS = {
  NOTES: 'notes',
  USER_SETTINGS: 'userSettings',
  AREAS_OF_FOCUS: 'areasOfFocus',
  NOTEBOOKS: 'notebooks',
  USER_PANEL_CONFIGS: 'userPanelConfigs',
  DRY_CHROME: 'dryChrome',
  SYSTEM: 'system',
  AREAS_OF_FOCUS_COLLECTIONS: 'areasOfFocusCollections',
  PENDING_WRITES: 'pendingWrites',
  NOTE_HISTORY: 'noteHistory',
};

constants.STORAGE_KEYS = {
  DRYCHROMECLASS: 'dryChromeClass', // General key for filtering
  DRYCHROMECLASS_V1: 'dryChromeClass_v1',
  DRYCHROMECLASSSMALL_V1: 'dryChromeClassSmall_v1',
  DRYCHROMECLASS_V2: 'dryChromeClass_v2',
  DRYCHROMECLASSSMALL_V2: 'dryChromeClassSmall_v2',
  AREAS_OF_FOCUS_COLLECTIONS: 'areasOfFocusCollections_v1', // DB table for AOF
};

constants.COOKIE_KEYS = {
  userID: 'dry_token',
  jwt: 'dry_jwt',
};

constants.SELECTED_NOTEBOOK = {
  notebook_name: 'All Notes',
  notebook_id: 'all_notes',
  notebook_path: '/notebooks/all_notes',
  special: true,
};

module.exports = constants;
